import { nanoid } from 'nanoid';
import { Transforms } from 'slate';
import { unwrapNodes } from '../../../../../slatePlugins/transforms/unwrapNodes';
import { isInsideOfElement } from '../../../helpers/selection';
import { wrapBlockAtSelection } from '../../../helpers/toggleBlockAtSelection';
import { getWrapLinkRange } from '../../hyper-link/transform/getWrapLinkRange';
import { ELEMENT_NOTE } from '../defaults';

const isNoteActive = (editor) => isInsideOfElement(editor, ELEMENT_NOTE);

export const unwrapHoverCardById = (editor, elementId) => {
  Transforms.unwrapNodes(editor, { at: [], match: (n: any) => n?.id === elementId });
};

const unwrapNote = (editor) => {
  unwrapNodes(editor, {
    match: { type: ELEMENT_NOTE } as any,
  });
};

const wrapNote = (editor) => {
  if (isNoteActive(editor)) {
    unwrapNote(editor);
  }
  const at = getWrapLinkRange(editor, editor.selection);

  wrapBlockAtSelection(
    editor,
    ELEMENT_NOTE,
    {
      id: nanoid(),
      isCreate: true,
    },
    { at }
  );
};

export const updateNoteContent = ({ editor, elementId, content }) => {
  Transforms.setNodes(
    editor,
    { noteContent: content },
    {
      at: [],
      match: (n: any) => {
        return n?.id === elementId;
      },
    }
  );
};

export const insertNote = (editor, content = null) => {
  if (editor.selection) {
    wrapNote(editor);
  }
};
